import React from 'react';
import { Box, Image } from '@chakra-ui/core';

import ArrowButtonIcon from '../../assets/arrowbutton.png';
import ArrowButtonDisabled from '../../assets/arrowbutton_disabled.png';

const ArrowButton = ({
  onClick,
  large = false,
  style: propsStyle = {},
  disabled = false,
  ...props
}) => {
  let style = {};

  return (
    <Box
      as="button"
      onClick={onClick}
      style={{ ...style, ...propsStyle }}
      disabled={disabled}
      {...props}
    >
      <Image height="3rem" src={disabled ? ArrowButtonDisabled : ArrowButtonIcon} />
    </Box>
  );
};

export default ArrowButton;
